module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32x32-8e079d463987b8419326b6fd4324492c.png";